<script setup>
import { onMounted, useTemplateRef } from "vue";
import Loader from "../Common/Loader.vue";
import ArticleList from "./ArticleList.vue";
import { useResultsStore } from "../../stores/results";

const props = defineProps({
  filters: {
    type: Object,
    required: true,
  },
  headlineTag: {
    type: String,
    default: "h2",
  },
  isReloading: {
    type: Boolean,
    default: false,
  },
});

// Stores
const resultsStore = useResultsStore();

// Handle infinite loading
const loadTrigger = useTemplateRef("loadTrigger");
onMounted(() => {
  observer = new IntersectionObserver(([entry]) => {
    if (resultsStore.results.articles.length === 0) {
      // Don't load more if there are no current results
      return;
    }

    if (entry.isIntersecting) {
      loadMore();
    }
  });

  observer.observe(loadTrigger.value);
});

async function loadMore() {
  const lastArticle = resultsStore.results.articles[resultsStore.results.articles.length - 1];
  resultsStore.fetchResults(props.filters, "append", lastArticle?.timestamp);
}
</script>

<template>
  <div class="min-h-[60vh] relative">
    <div class="size-20 absolute top-10 left-1/2 -translate-x-1/2 z-20">
      <Loader v-if="props.isReloading" class="size-full text-primary" />
    </div>

    <ArticleList
      class="transition-opacity"
      :class="props.isReloading ? 'opacity-70 pointer-events-none' : ''"
      :headline-tag="props.headlineTag"
      :articles="resultsStore.results.articles"
    />

    <!-- The position of this line (from the bottom) defines how early the infinite load triggers -->
    <div ref="loadTrigger" class="absolute left-0 bottom-[100vh] h-px w-full"></div>

    <Loader
      v-if="resultsStore.isLoading && resultsStore.results.articles.length > 0"
      class="size-20 mx-auto mt-10 text-primary"
    />
  </div>
</template>
